<template>
  <upModel
    :title="title"
    :show="show"
    @close="close"
    :showCloseBtn="true"
    :autoHeight="true"
    :buttons="
      showCloseBtn
        ? [
            {
              label: label,
              onClick: () => $emit(customClose ? 'customClose' : 'close')
            }
          ]
        : []
    "
    class="hp-up-popup-container"
  >
    <div class="hp-up-popup-rule-model" ref="ruleModel">
      <slot></slot>
      <slot name="bottom"></slot>
    </div>
  </upModel>
</template>

<script>
import upModel from 'lib/component/vue/upModel/upModel.vue'
import preventScrollChain from 'utils/preventScrollChain.js'

export default {
  components: {
    upModel
  },
  props: {
    title: String,
    show: {
      type: Boolean,
      default: false
    },
    showCloseBtn: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '关闭'
    },
    customClose: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    show(val) {
      this.$nextTick(() => {
        if (!!val) {
          preventScrollChain(this.$refs.ruleModel)
        } else {
          preventScrollChain.destory()
        }
      })
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
@import '~lib/scss/functions.scss';

.hp-up-popup-container {
  // 覆盖弹窗的样式
  .common-model-up-title {
    padding-bottom: pxToRem(16);
  }
}

.hp-up-popup-rule-model {
  padding: pxToRem(20) pxToRem(28);
  box-sizing: border-box;
  max-height: calc(100vh - 4rem);
  overflow: hidden;
  overflow-y: auto;
}
</style>
